import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  useOutsideClick,
} from '@chakra-ui/react';
import { useRef } from 'react';
import { DropdownIcon } from '~/components/AutocompleteDropdown/DropdownIcon';
import { DropdownMenu } from '~/components/AutocompleteDropdown/DropdownMenu';
import { InputDropdownProps } from '~/components/AutocompleteDropdown/types';
import theme from '~/styles/theme';

export const AutocompleteDropdown: React.FC<InputDropdownProps> = ({
  inputProps,
  isDisabled,
  isOpen,
  options,
  placeholder,
  selectedValue,
  value,

  onChange,
  onSelect,
  onRemove,
  onMenuOpen,
  onMenuClose,

  ...props
}) => {
  const inputWrapperRef = useRef<HTMLDivElement>(null);

  useOutsideClick({
    ref: inputWrapperRef,
    handler: () => {
      if (isOpen) {
        onMenuClose();
      }
    },
  });

  return (
    <Box ref={inputWrapperRef} {...props}>
      <Flex as={InputGroup} marginBottom={2} position="relative">
        <Input
          placeholder={placeholder}
          _placeholder={{ color: 'primary.300' }}
          borderRadius="full"
          color="primary.700"
          borderColor="primary.100"
          _hover={{
            cursor: 'pointer',
            border: `1px solid ${theme.colors.primary[500]}`,
            outline: `4px solid ${theme.colors.primary[50]}`,
            outlineOffset: 0,
          }}
          _active={inputStyle}
          _pressed={inputStyle}
          _focusVisible={inputStyle}
          _focus={{
            border: `1px solid ${theme.colors.secondary[500]}`,
            outline: `4px solid ${theme.colors.secondary[50]}`,
            outlineOffset: 0,
          }}
          onClick={onMenuOpen}
          value={value}
          onChange={onChange}
          isDisabled={isDisabled}
          {...inputProps}
        />

        <InputRightElement marginRight={1}>
          <DropdownIcon
            isOpen={isOpen}
            isSelected={Boolean(selectedValue)}
            isDisabled={isDisabled}
            onRemove={onRemove}
            onOpen={onMenuOpen}
            onClose={onMenuClose}
          />
        </InputRightElement>
      </Flex>

      {isOpen && (
        <DropdownMenu
          selectedValue={selectedValue}
          options={options}
          onSelect={onSelect}
        />
      )}
    </Box>
  );
};

const inputStyle = {
  border: `1px solid ${theme.colors.secondary[500]}`,
  outline: `4px solid ${theme.colors.secondary[50]}`,
  outlineOffset: 0,
};
